export const volumes = [
  {
    n: 1,
    title: "Speech Sound Foundations & Planning Framework",
    tagline: "Build a clearer foundation for organizing your articulation-related work.",
    body: "This volume introduces key concepts related to speech sound development and provides a structured starting point for organizing relevant information before planning activities.",
    items: [
      "An educational overview of speech sound terminology.",
      "Worksheets for organizing relevant case information.",
      "A framework for documenting speech sound observations.",
      "Planning prompts for identifying questions requiring further assessment.",
      "Templates for recording priorities and next steps.",
    ],
    closing: "The purpose is to help you organize relevant information before deciding what requires attention.",
    soft: "bg-[#e8f2ff]",
    badge: "bg-[#2f7cf6] text-white",
    check: "text-[#2f7cf6]",
  },
  {
    n: 2,
    title: "Speech Sound Observation & Documentation Workbook",
    tagline: "Bring your observations together in one organized place.",
    body: "Before planning activities, you need a clear record of what you've observed and which questions remain unanswered. This volume provides tools for organizing observations without presenting them as a substitute for a comprehensive assessment.",
    items: [
      "Speech sound observation worksheets.",
      "Word and context recording templates.",
      "Structured spaces for recording relevant examples.",
      "Documentation prompts for noting patterns that may require further investigation.",
      "Follow-up worksheets for organizing additional questions.",
    ],
    closing: "Use these resources to support documentation within your professional workflow.",
    soft: "bg-[#e3f6ee]",
    badge: "bg-[#0f8a58] text-white",
    check: "text-[#0f8a58]",
  },
  {
    n: 3,
    title: "Articulation Target Planning & Session Organizer",
    tagline: "Organize your session priorities and planning decisions.",
    body: "Different children have different communication needs, and their plans should reflect individualized professional decisions. This volume helps you organize relevant targets, session priorities, and activity plans.",
    items: [
      "Target planning worksheets.",
      "Session objective organizers.",
      "Templates for connecting activities with documented goals.",
      "Planning sheets for organizing practice opportunities.",
      "Review prompts for documenting decisions and possible adjustments.",
    ],
    closing: "The worksheets provide structure while leaving clinical decisions in your hands.",
    soft: "bg-[#ffeee6]",
    badge: "bg-[#d4502a] text-white",
    check: "text-[#d4502a]",
  },
  {
    n: 4,
    title: "Articulation Activities & Visual Practice Resources",
    tagline: "Keep practical activity ideas and visual resources organized.",
    body: "Preparing educational materials can take time, particularly when you're looking for resources that fit a specific target and activity. This volume brings together examples and organizers for preparing speech sound practice materials.",
    items: [
      "Picture-based activity planning templates.",
      "Word list organization worksheets.",
      "Examples of activities for different practice contexts.",
      "Visual material planning sheets.",
      "Adaptation checklists for preparing age-appropriate resources.",
    ],
    closing: "The materials are educational starting points that you can review and adapt to each child's needs.",
    soft: "bg-[#f1ebff]",
    badge: "bg-[#7448e8] text-white",
    check: "text-[#7448e8]",
  },
  {
    n: 5,
    title: "Family Communication & Home Practice Planner",
    tagline: "Organize the information you share with families.",
    body: "When home practice is appropriate, families benefit from clear information about the activities and recommendations provided by their child's speech-language pathologist. This volume helps you organize communication and follow-up materials.",
    items: [
      "Family discussion worksheets.",
      "Home practice planning templates.",
      "Activity information sheets.",
      "Communication and follow-up organizers.",
      "Templates for documenting agreed-upon practice arrangements.",
    ],
    closing: "The focus is on organizing information and supporting collaboration, not assigning families a clinical role.",
    soft: "bg-[#fff5d6]",
    badge: "bg-[#ffc93c] text-[#0f2557]",
    check: "text-[#a86f00]",
  },
  {
    n: 6,
    title: "Speech Sound Progress Documentation & Follow-Up Planner",
    tagline: "Keep observations, session records, and follow-up questions organized.",
    body: "A consistent documentation process can make it easier to review information gathered over time. This volume provides a structured way to organize records and prepare for follow-up discussions.",
    items: [
      "Session documentation templates.",
      "Observation tracking worksheets.",
      "Progress review organizers.",
      "Follow-up planning checklists.",
      "Worksheets for documenting questions and possible next steps.",
    ],
    closing: "These tools support professional record organization; they do not independently establish treatment effectiveness or determine when a child has mastered a speech sound.",
    soft: "bg-[#e3f3fd]",
    badge: "bg-[#1676b8] text-white",
    check: "text-[#1676b8]",
  },
];
